import { Injectable } from '@angular/core';
import { AppHttpClient } from './app-http-client.service';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class ApproachProfileService {

  constructor(
    public http : AppHttpClient,
    public util : UtilService
  ) { }

  getProfiles(filterValues:any){
    return this.http.get('approach-profiles', filterValues);
  }

  createProfile(payload: any){
    return this.http.post('approach-profiles', payload);
  }

  updateProfile(payload: any){
    return this.http.put('approach-profiles', payload);
  }

  deleteProfile(params: any){
    return this.http.delete('approach-profiles', { params });
  }

  copyProfiles(params: any){
    const qs = new URLSearchParams(params).toString();
    return this.http.post('approach-profiles?' + qs, {});
  }

  yearOptions:any[] = [];
  renewalYearOptions() {
    // console.log('Renewal Year Options:', this.yearOptions);
    if(this.yearOptions.length) return this.yearOptions;

    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = -2; i <= 1; i++) {
      const year = (currentYear + i).toString();
      years.push({ label: year, value: year });
    }
    this.yearOptions = years;
    return years;
  }

}
